<template>
  <div class="cpm-wrapper">
    <el-dialog title="查看随货资质" :visible.sync="dialogVisible" width="490px" :close-on-click-modal="false">
      <div class="cpm-content">
        <!-- <div class="store-wrapper">
          <img
            class="logo"
            v-if="orderInfo.shopIcon"
            :src="orderInfo.shopIcon + '?x-oss-process=image/resize,w_72/quality,q_90'"
            alt=""
          />
          <img class="logo" v-else :src="require('@/assets/img/shop-logo.png')" alt="" />
          <span class="store-name">{{ orderInfo.shopName }}</span>
        </div> -->
        <div
          v-if="
            orderInfo.followGoodsCertification &&
              orderInfo.followGoodsCertification.merchantQualifications &&
              orderInfo.followGoodsCertification.merchantQualifications.length
          "
          class="sub-tittle"
        >
          企业相关资质
        </div>
        <div
          v-if="
            orderInfo.followGoodsCertification &&
              orderInfo.followGoodsCertification.merchantQualifications &&
              orderInfo.followGoodsCertification.merchantQualifications.length
          "
          class="list"
        >
          <span class="text">{{ orderInfo.followGoodsCertification.merchantQualifications.join('、') }}</span>
        </div>
        <div class="sub-tittle">商品相关资质</div>
        <div
          v-if="
            orderInfo.followGoodsCertification &&
              orderInfo.followGoodsCertification.itemQualifications &&
              orderInfo.followGoodsCertification.itemQualifications.length
          "
          class="certification-wrapper"
        >
          <div
            :key="index"
            v-for="(item, index) in orderInfo.followGoodsCertification.itemQualifications.slice(
              (fontCurrentPage - 1) * 5,
              fontCurrentPage * 5
            )"
            class="goods-wrapper"
          >
            <img class="goods-img" v-if="item.itemThumbnail" :src="item.itemThumbnail" alt="" />
            <img class="goods-img" v-else :src="require('@/assets/img/goods-empty.png')" alt="" />
            <div class="goods-info">
              <div class="goods-title">{{ item.itemName }} {{ item.spec }}</div>
              <div class="goods-certification">
                具有资质：
                <span v-if="item.drugReport">检验报告</span>
                <span v-if="item.sellQualification">、首营资料</span>
              </div>
            </div>
          </div>
          <el-pagination
            v-show="orderInfo.followGoodsCertification.itemQualifications.length > 5"
            @current-change="handleCurrentChange"
            :page-size="5"
            layout=" prev, pager,next"
            :total="orderInfo.followGoodsCertification.itemQualifications.length"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" style="textAlign:right">
        <el-button style="border-radius:0" type="primary" @click="onSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('order', ['preOrderInfo'])
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.orderInfo = this.info;
        }
      }
    }
  },
  mounted() {},
  data() {
    return {
      orderInfo: {},
      dialogVisible: false,
      fontCurrentPage: 1,
      selectedShopCerti: []
    };
  },
  methods: {
    onSubmit() {
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.fontCurrentPage = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-content {
    margin-top: -8px;
    .sub-tittle {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      margin-top: 16px;
      margin-bottom: 8px;
    }
    .list {
      .text {
        height: 22px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        line-height: 22px;
      }
    }
    ::v-deep .chooseItemCls {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      width: auto;
      padding: 0 16px;
      margin-bottom: 8px;
    }
    .store-wrapper {
      display: flex;
      align-items: center;
      .logo {
        width: 30px;
        height: 30px;
      }
      .store-name {
        margin-left: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
      }
    }
    .goods-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .goods-img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
      .goods-info {
        flex: 1;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        ::v-deep .el-checkbox__label {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
  .el-pagination {
    text-align: right;
  }
}
</style>
